<template>
    <div class="off-risk-declaration-info">
        <h3>Off Risk Declaration Request</h3>
        <field-group title="Final Premium:">
            <p>{{ finalPremium | currency(currencyCode)  }}</p>
        </field-group>
        <field-group title="Off Risk Date:">
            <p>{{ offRiskDate }}</p>
        </field-group>
        <div class="text-xs-right">
            <x-btn v-if="hasOffRiskRequestToRespondTo" @click="accept()" class="save-icon pull-right" color="success" title="Accept">Accept</x-btn>
            <x-btn v-else class="save-icon pull-right" disabled>Pending</x-btn>
        </div>

        <modal
            ref="confirmOffRisk"
            title="Accept Off Risk Declaration Request"
            confirmation
        >
            <p>
                Are you sure?
            </p>
        </modal>
    </div>
</template>

<script>
    import Modal from '~/components/Shared/UIComponents/Modal';

    export default {
        name: "OffRiskApproval",
        components: {
            Modal,
        },
        props: ['offRiskRequest', 'currencyCode', 'hasOffRiskRequestToRespondTo', 'lineId'],
        data() {
            return {
            }
        },
        computed: {
            offRiskDate: function() {
                return this.$moment(this.offRiskRequest.effective_date).format('DD/MM/YYYY');
            },
            finalPremium: function() {
                return this.offRiskRequest.field_changes.lines.find(line => line.id === this.lineId).final_premium;
            }
        },
        methods: {
            async accept() {
                if (await this.$refs.confirmOffRisk.open() === false) {
                    return;
                }

                axios.put(this.$root.api(`insurer/endorsement/${this.offRiskRequest.id}/accept`))
                    .then(function () {
                        this.$eventBus.$emit('declarationChanged');
                    }.bind(this));
            },
        },
    }
</script>


<style lang="scss" scoped>
    .off-risk-declaration-info {
        border: 1px solid rgba(251,140,0, .5);
        background: rgba(251,140,0, .1);
        padding: 0 0 50px 0;
        margin-bottom: 20px;

        h3 {
            margin: 10px;
        }
    }
</style>
